import { RouteConfig } from 'vue-router';

import NewEntryPage from '@/pages/index/pages/new/NewEntryPage.vue';
import { refreshToken } from '@/router/guards/refreshToken';


export const newEntryPageRoute: RouteConfig = {
  beforeEnter: refreshToken,
  meta: {
    title: 'New Entry',
  },
  path: '/new',
  component: NewEntryPage,
};
